var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpgColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.36,
    height: 22.76,
    viewBox: "0 0 17.36 22.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JPG",
    transform: "translate(-1 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M18.35,22.08a.681.681,0,0,1-.67.69H1.67A.681.681,0,0,1,1,22.08V.7A.681.681,0,0,1,1.67.01H13.48c.87.93,4.51,4.47,4.88,4.94V22.07Z",
    fill: "#e0f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M18.35,15.86H1v6.2a.681.681,0,0,0,.67.69H17.69a.681.681,0,0,0,.67-.69V15.87Z",
    fill: "#4e66cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M13.51.02V4.31a.628.628,0,0,0,.62.61h4.18Z",
    fill: "#99badb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M6.59,17.98h.57v2.3a1.137,1.137,0,0,1-.08.43,1.016,1.016,0,0,1-.22.32,1.053,1.053,0,0,1-.34.2,1.177,1.177,0,0,1-.43.07,1.442,1.442,0,0,1-.43-.06,1.008,1.008,0,0,1-.34-.18.793.793,0,0,1-.22-.31,1.176,1.176,0,0,1-.08-.43h.57a.575.575,0,0,0,.04.24.488.488,0,0,0,.1.16.417.417,0,0,0,.16.09.665.665,0,0,0,.21.03.5.5,0,0,0,.36-.15.524.524,0,0,0,.1-.18.625.625,0,0,0,.04-.25v-2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M8.38,20.04v1.22H7.81V17.98H9.06a1.6,1.6,0,0,1,.51.08,1.027,1.027,0,0,1,.38.22.856.856,0,0,1,.23.33,1.162,1.162,0,0,1,.08.42,1.176,1.176,0,0,1-.08.43.821.821,0,0,1-.23.32,1.056,1.056,0,0,1-.38.2,1.613,1.613,0,0,1-.51.07H8.38Zm0-.46h.68a.788.788,0,0,0,.28-.04.414.414,0,0,0,.19-.12.418.418,0,0,0,.11-.18.822.822,0,0,0,0-.44.524.524,0,0,0-.11-.19.641.641,0,0,0-.19-.13.778.778,0,0,0-.28-.05H8.38v1.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M13.27,20.84a1.326,1.326,0,0,1-.14.15.9.9,0,0,1-.24.15,1.431,1.431,0,0,1-.35.12,2.283,2.283,0,0,1-.48.05,1.523,1.523,0,0,1-.57-.11,1.139,1.139,0,0,1-.44-.31,1.481,1.481,0,0,1-.29-.49,1.968,1.968,0,0,1-.1-.67v-.22a2.311,2.311,0,0,1,.09-.67,1.338,1.338,0,0,1,.27-.5,1.149,1.149,0,0,1,.42-.31,1.485,1.485,0,0,1,.57-.11,1.623,1.623,0,0,1,.52.08,1.027,1.027,0,0,1,.38.22,1,1,0,0,1,.24.33,1.455,1.455,0,0,1,.12.42h-.56a.951.951,0,0,0-.07-.24.8.8,0,0,0-.13-.19.448.448,0,0,0-.2-.12.836.836,0,0,0-.29-.05.948.948,0,0,0-.35.07.581.581,0,0,0-.25.22,1.121,1.121,0,0,0-.15.35,1.739,1.739,0,0,0-.05.47v.22a1.75,1.75,0,0,0,.06.48,1.039,1.039,0,0,0,.17.35.729.729,0,0,0,.27.22.782.782,0,0,0,.35.07.936.936,0,0,0,.25-.02.776.776,0,0,0,.18-.05.666.666,0,0,0,.12-.06.571.571,0,0,0,.08-.07v-.64h-.68v-.43h1.24v1.26Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M11.77,6.44H5.93a.516.516,0,0,0-.52.52V12.8a.516.516,0,0,0,.52.52h5.84a.516.516,0,0,0,.52-.52V6.96a.516.516,0,0,0-.52-.52Zm-5.89.52s.02-.05.05-.05h5.84s.05.02.05.05v3.69L10.46,8.82,8.6,11.38l-1.18-.96L5.87,11.87V6.95Z",
    fill: "#adadad"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 0.45,
    cy: 0.45,
    r: 0.45,
    transform: "translate(6.71 7.7)",
    fill: "#adadad"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpgColorIcon);
export default __webpack_public_path__ + "static/media/jpg-color-icon.15cf4a5e3ecb97622b94b4540d1eef51.svg";
export { ForwardRef as ReactComponent };